/// <amd-module name="Agile/Common/Redux/HubTeam/HubTeamReducer" />
import { IHubTeamState } from "Agile/Common/Redux/HubTeam/HubTeamContracts";
import { HubTeamActions, HubTeamActionTypes } from "Agile/Common/Redux/HubTeam/HubTeamActions";
import produce from "immer";

export function hubTeamReducer(state: IHubTeamState, action: HubTeamActions): IHubTeamState {
    return produce(state || {}, (draft: IHubTeamState) => {
        switch (action.type) {
            case HubTeamActionTypes.Initialize: {
                const { team } = action.payload;
                draft.team = team;
                break;
            }
        }
    });
}
